module.exports = __webpack_public_path__ + "static/media/3.1dd85172.png";